var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$parent.experiment.slug},[_c('div',{staticClass:"screen-content",class:'h-' + _vm.screen.hash},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.screen.html)},on:{"click":function($event){return _vm.click($event)}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }